<template>
  <div class v-if="dataModel != null">
    <!-- header start -->
    <van-nav-bar
      title="开通会员"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group class="martop0">
      <div class="panel-info">
        <span class="label">会员类型：</span>
        <span class="text">{{ dataModel.DistributionLevelName }}</span>
      </div>
    </van-cell-group>
    <van-cell-group
      v-if="dataModel.IDistributionProductApiModelList.length > 0"
    >
      <div class="panel-info">
        <span class="label">产品选择：</span>
        <span class="text">{{ dataModel.DistributionLevelName }}赠送产品</span>
      </div>
      <div class="pro-radio-group">
        <van-radio-group v-model="proRadio" @change="onChangePorduct">
          <van-radio
            v-for="(item, index) in dataModel.IDistributionProductApiModelList"
            :key="index"
            :name="item.DProductId"
          >
            <template>
              <div class="goods-list">
                <div class="hd">
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="item.CoverPhoto"
                  />
                </div>
                <div class="bd">
                  <div class="title">
                    <h2 class="name">{{ item.DProductName }}</h2>
                  </div>
                  <div class="des">{{ item.Subtitle }}</div>
                  <div class="price">￥{{ item.Price }}</div>
                </div>
              </div>
            </template>
          </van-radio>
        </van-radio-group>
      </div>
    </van-cell-group>

    <van-cell-group
      v-if="dataModel.IDistributionProductApiModelList.length > 0"
    >
      <!-- <div class="panel-info">
        <span class="label">收货人信息</span>
      </div>
      <van-field placeholder="姓名" v-model.trim="inputText.Name" />
      <van-field type="tel" placeholder="手机号码" v-model.trim="inputText.Phone" />
      <van-field
        v-model="areaListInput"
        placeholder="选择省 / 市 / 区"
        is-link
        readonly
        @click="arealistShow = true;"
      />
      <van-field placeholder="详细地址，如街道、楼盘号等" v-model.trim="inputText.AddressPart" />
      <van-field placeholder="邮编地址" v-model.trim="inputText.Postcode" /> -->
      <div
        class="address-box"
        v-if="memberAddress === null"
        @click="goAddress()"
        tapmode
      >
        <div class="address-box-in">
          <div class="address-box-top">
            <div>没有地址点击添加</div>
          </div>
        </div>
        <div class="right-box">
          <van-icon name="arrow" />
        </div>
      </div>
      <div
        class="address-box"
        v-if="memberAddress !== null"
        @click="goAddress()"
        tapmode
      >
        <div class="address-box-in">
          <div class="address-box-top">
            <div>{{ memberAddress.Name }}</div>
            <div>{{ memberAddress.Phone }}</div>
          </div>
          <div class="address-box-bottom">
            {{ replaceStr(memberAddress.AreaNames) + memberAddress.Address }}
          </div>
        </div>
        <div class="right-box">
          <van-icon name="arrow" />
        </div>
      </div>
    </van-cell-group>
    <van-radio-group v-model="inputText.PayType">
      <van-cell-group title="请选择支付方式">
        <van-cell clickable @click="inputText.PayType =1">
          <van-radio slot="right-icon" :name="1"  />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/weixin.png" />
              <div class="flexmid">
                <p class="tit">微信支付</p>
              </div>
            </div>
          </template>
        </van-cell>
        <van-cell clickable @click="inputText.PayType =2">
          <van-radio slot="right-icon" :name="2" />
          <template slot="title">
            <div class="paystyle-list">
              <img src="@/assets/images/balance.png" />
              <div class="flexmid">
                <p class="tit">积分支付({{member!=null?member.HasIntegral:0 }})</p>
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

    <div class="btn-area">
      <van-button block color="orange" @click="onSubmit" size="large"
        >确定支付</van-button
      >
    </div>

    <!-- 选择省 / 市 / 区 popup start -->
    <van-popup v-model="arealistShow" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="3"
        value="110101"
        @confirm="onConfirmAreaList"
        @cancel="arealistShow = false"
        @change="onAreaListChange"
      />
    </van-popup>
    <!-- 选择省 / 市 / 区 popup end -->
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Toast } from "vant";
import AreaList from "@/assets/js/area";
export default {
  data() {
    return {
      proRadio: "",
      arealistShow: false,
      areaList: AreaList,
      areaListInput: "",
      inputText: {
        Name: "",
        Phone: "",
        Address: "",
        AddressPart: "",
        Postcode: "",
        DistributionLevelId: "",
        DProductId: "",
        PayType:1
      },
      member:null,
      dataModel: null,
    };
  },
  components: {},
  computed: {
    ...mapState({
      memberAddress: (state) => state.addressManage.memberAddress,
    }),
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    var _query = this.$route.query;
    //console.log(_query);
    this.init(_query.id, _query.pid);
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init(id, pid) {
      var that = this;
      this.GetMemberInfo();
      var params = {
        type: "GetDistributionLevelById",
        Id: id,
      };

      that.$store.dispatch(params).then(
        (res) => {
          console.log(res, "init......");
          if (pid != null) {
            that.proRadio = pid;
          } else {
            if (
              res.DistributionLevelApiModel.IDistributionProductApiModelList !=
                null &&
              res.DistributionLevelApiModel.IDistributionProductApiModelList
                .length > 0
            ) {
              that.proRadio =
                res.DistributionLevelApiModel.IDistributionProductApiModelList[0].DProductId;
            }
          }

          that.dataModel = res.DistributionLevelApiModel;
          that.inputText.DistributionLevelId =
            that.dataModel.DistributionLevelId;
        },
        (error) => {}
      );
    },
    GetMemberInfo(){
      var that = this;
        this.$store
          .dispatch({
            type: "GetMemberInfo"
          })
          .then(res => {
            that.member = res;
        });
    },
    onSubmit() {
      var that = this;
      var params;
      if (that.dataModel.IDistributionProductApiModelList.length > 0) {
        // if (that.inputText.Name == "") {
        //   Toast("姓名不能为空！");
        //   return false;
        // }
        // if (that.inputText.Phone == "") {
        //   Toast("手机号不能为空！");
        //   return false;
        // } else {
        //   var regPhone = /^[1][0-9]{10}$/;
        //   if (!regPhone.test(that.inputText.Phone)) {
        //     Toast("请输入正确的手机号");
        //     return false;
        //   }
        // }
        // if (that.areaListInput == "") {
        //   Toast("请选择省市区");
        //   return false;
        // }
        // if (that.inputText.AddressPart == "") {
        //   Toast("详细地址不能为空");
        //   return false;
        // } else {
        //   let reg = new RegExp("/", "g");
        //   that.inputText.Address = (
        //     that.areaListInput + that.inputText.AddressPart
        //   ).replace(reg, "");
        // }
        if(that.memberAddress==null){
          Toast("请选择地址再进行支付!");
           return false;
        }

        that.inputText.mid = that.memberAddress.SerialNumber;
        that.inputText.DProductId = that.proRadio;
      } else {
        that.inputText.mid = "";
        that.inputText.DProductId = "";
      }
      params = that.inputText;
      // console.log(params,"MemberBuy");
      // return;
      Object.assign(params, {
        type: "DistributionLevelTransactionrAdd",
      });
      // console.log(params);
      that.$store.dispatch(params).then((res) => {
        Toast(res.Message);
        if (res.IsSuccess) {
          if(that.inputText.PayType==1){
            that.weiXinPay(res.Information);
          }else{
            that.$router.replace("/OrderList");
          }
        } else {
         
        }
      });
    },
    weiXinPay(orderId) {
      //找到订单编号支付
      var that = this;
      var _openId = sessionStorage.getItem("OpenId");
      var _options = {
        type: "WeiXinPay",
        orderId: orderId,
        openid: _openId,
      };
      //console.log(_options);
      that.$store.dispatch(_options).then(
        (res) => {
          console.log(res);
          that.$weixin.weiXinPay(
            res,
            function() {
              that.getMember();
              that.$router.replace("/OrderList"); //支付成功跳转到订单列表
            },
            function() {
              that.$router.replace("/OrderList");
            }
          );
        },
        (error) => {}
      );
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onChangePorduct(val) {
      //console.log(val);
      this.inputText.DProductId = val;
    },
    onConfirmAreaList(data) {
      console.log(data);
      // var areaValue = picker.getValues();
      // console.log(areaValue);
      var _address = "";
      var _areaValue = "";
      var _oldText = "";
      data.forEach((element) => {
        var _isrepeat = false;
        if (_oldText != "") {
          if (_oldText == element.name) {
            _isrepeat = true;
          }
        }
        if (!_isrepeat) {
          _address += element.name;
        }
        _oldText = element.name;
        if (_areaValue != "") {
          _areaValue += "/";
        }
        _areaValue += element.name;
      });
      //console.log(_address);
      this.areaListInput = _address;
      this.arealistShow = false;
    },
    /*选择省 / 市 / 区*/
    onAreaListChange(picker) {
      var areaValue = picker.getValues();
      console.log(areaValue);
      this.areaListInput =
        areaValue[0].name +
        " / " +
        areaValue[1].name +
        " / " +
        areaValue[2].name;
    },
    getMember() {
      var _options = {
        type: "GetMemberIndex",
      };
      this.$store.dispatch(_options);
    },
    goAddress() {
      this.$router.push("addressManage");
    },
    replaceStr(str) {
      var _text = "";
      _text = str.replace(/-/g, "");
      return _text;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "AddressManage") {
      to.meta.refresh = false;
    } else {
      to.meta.refresh = true;
    }
    next();
  },
};
</script>

<style scoped>
.panel-info {
  padding: 12px 16px;
  font-size: 17px;
}
.panel-info .label {
  color: #888;
}
.pro-radio-group {
  padding: 0 16px;
}
.pro-radio-group >>> .van-radio__label {
  overflow: hidden;
  flex: 1;
}
.van-cell-group {
  margin-top: 8px;
}
.goods-list {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.goods-list > .hd {
  width: 60px;
  height: 60px;
  margin-right: 14px;
}
.goods-list > .bd {
  flex: 1;
  overflow: hidden;
}
.goods-list > .bd .title {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.goods-list > .bd .title .name {
  font-size: 15px;
  color: #444;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.goods-list > .bd .des {
  font-size: 12px;
  color: #999;
}
.goods-list > .bd .price {
  font-size: 12px;
  color: crimson;
  margin-top: 4px;
}

.address-box {
  width: 100%;
  height: auto;
  background-color: #fff;
  padding: 14.28px 11.76px 14.28px 11.76px;
  position: relative;
}

.address-box-top {
  width: 100%;
  height: auto;
  font-size: 14.91px;
  color: #333333;
  display: flex;
  align-items: center;
}

.address-box-top div {
  margin-right: 7.98px;
}

.address-box-bottom {
  max-width: 80%;
  font-size: 12.999px;
  color: #666666;
  margin-top: 4.2px;
}

.right-box {
  position: absolute;
  width: 21px;
  height: 21px;
  top: 0;
  bottom: 0;
  right: 0px;
  margin: auto;
  font-size: 15.75px;
  color: #999999;
}


.paystyle-list {
  display: flex;
  align-items: center;
}
.paystyle-list img {
  width: 32px;
  height: 32px;
  margin-right: 15px;
}
.paystyle-list .tit {
  font-size: 15px;
}
.paystyle-list .des {
  font-size: 12px;
  color: #999;
}
.paystyle-list .payDisableIcon {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: auto;
  margin: 0;
}
</style>
